export const DIALOG_OPERATION_FEEDBACK_FORM_CONST = {
    tNamespace: "dialogs",
    tPaths: {
        defaultHeader: "feedback-form.header.default",
        successHeader: "feedback-form.header.success",
        errorHeader: "feedback-form.header.error",
        rate: "feedback-form.rate",
        defaultSuggestion: "feedback-form.suggestion.default",
        successSuggestion: "feedback-form.suggestion.success",
        errorSuggestion: "feedback-form.suggestion.error",
        feedback: "feedback-form.feedback",
        feedbackPlaceholder: "feedback-form.feedback-placeholder",
        retryButton: "feedback-form.retry-button",
        validation: "feedback-form.validation"
    },
    testIds: {
        closeButton: "feedback-form-close-button",
        submitButton: "feedback-form-submit-button",
        retryButton: "feedback-form-retry-button",
        feedback: "feedback-form-feedback",
        rating: "feedback-form-rating",
        heartIcon: "feedback-form-heart-icon",
        robotSuccess: "feedback-form-robot-success",
        robotDefault: "feedback-form-robot-default"
    }
}
